export const agregateFunctions = Object.freeze({
	SUM: 1,
	MAX: 2,
	MIN: 3,
	COUNT: 4,
});
